import dashboard from './dasboard.json';
import login from './login.json';
import rcl from './rcl.json';
import create from './create.json';
import rlr from './rlr.json';
import rpl from './rpl.json';
import users from './users.json';
import webhooks from './webhooks.json';
import workorders from './workorders.json';
import logistic from './logistic.json';
import miscelanea from './miscelanea.json';

export default {
  dashboard,
  login,
  rcl,
  create,
  rlr,
  rpl,
  users,
  webhooks,
  workorders,
  logistic,
  miscelanea,
};
